<template>
  <el-form-item label="显示">
    <el-switch v-model="prop.labelShow" size="small"> </el-switch>
  </el-form-item>
  <el-form-item label="标签字号">
    <el-input-number v-model="prop.labelShowFontSize" size="small" controls-position="right">
    </el-input-number>
  </el-form-item>
  <el-form-item label="标签字色" v-if="main.labelShowColorAuto != true">
    <colorPicker v-model="prop.labelShowColor"></colorPicker>
  </el-form-item>
  <el-form-item label="标签内容" v-if="main.labelShowColorAuto != true">
    <el-checkbox-group v-model="prop.labelContent">
      <el-checkbox label="引导线" />
      <el-checkbox label="维度值" />
      <el-checkbox label="指标值" />
    </el-checkbox-group>
  </el-form-item>
  <el-form-item label="标签标示" v-if="main.labelShowColorAuto != true">
    <el-radio-group v-model="prop.labelStyle">
      <el-radio label="1">跟随图例</el-radio>
      <el-radio label="2">自定义</el-radio>
    </el-radio-group>
  </el-form-item>
  <el-form-item label="标签位置" v-if="main.labelShowColorAuto != true">
    <el-select v-model="prop.labelPosition" size="small">
      <el-option label="图形内" value="inside"></el-option>
      <el-option label="图形外" value="top"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="字体粗细">
    <el-select v-model="prop.labelShowFontWeight" size="small">
      <el-option
        v-for="item in dicOption.fontWeight"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
  </el-form-item>
</template>
<script setup>
import { dicOption } from '@/option/config';
import colorPicker from "./color-picker.vue";
let props = defineProps({
  prop: {},
  main: {
    default() {
      return {};
    },
  },
});
</script>
<style scoped>
</style>